import { render, staticRenderFns } from "./c_product.vue?vue&type=template&id=5124ef32&scoped=true"
import script from "./c_product.vue?vue&type=script&lang=js"
export * from "./c_product.vue?vue&type=script&lang=js"
import style0 from "./c_product.vue?vue&type=style&index=0&id=5124ef32&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124ef32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5124ef32')) {
      api.createRecord('5124ef32', component.options)
    } else {
      api.reload('5124ef32', component.options)
    }
    module.hot.accept("./c_product.vue?vue&type=template&id=5124ef32&scoped=true", function () {
      api.rerender('5124ef32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_product.vue"
export default component.exports